module.exports = __webpack_public_path__ + "img/StudentPay-logo.627241f4.png";